import React from "react";
import { Link } from "react-router-dom";
import { ArrowDownToLine } from "lucide-react";

export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer-inner">
        <div className="public-footer-main">
          <div className="public-footer-about">
            <Link to="/" className="public-footer-brand"><img src="/eyloho.ico" alt="" /> Screenshot Monitor</Link>
            <p>Time tracking and work visibility for teams that need a clearer picture of the day.</p>
          </div>
          <nav aria-label="Product links"><h3>Explore</h3><a href="/#features">Features</a><a href="/#how-it-works">How it works</a><a href="/#reports">Reports</a></nav>
          <nav aria-label="Account links"><h3>Account</h3><Link to="/signup">Create account</Link><Link to="/login">Log in</Link><a href="/Screenshotmonitor.zip" download><ArrowDownToLine size={15} /> Desktop app</a></nav>
        </div>
        <div className="public-footer-bottom"><span>© {new Date().getFullYear()} Screenshot Monitor</span><span>Track time. See progress. Stay in sync.</span></div>
      </div>
    </footer>
  );
}
